/**
 * Configuration management for the Word add-in
 * Stores backend API URLs and other settings
 */

export interface AppConfig {
  BACKEND_API_URL: string;
}

/**
 * Default configuration
 * Backend API URL - Changed to Local Development (Proxied)
 */
export const CONFIG: AppConfig = {
  // Local backend URL (handled by webpack proxy)
  BACKEND_API_URL: "",
};

/**
 * Update configuration at runtime
 * @param config Partial configuration to merge
 */
export function updateConfig(config: Partial<AppConfig>): void {
  Object.assign(CONFIG, config);
}
